import {Modal} from "react-bootstrap";
import {TruckInfo} from "./NewEditTruckModal";
import {
    formatCardNumber,
    formatStandardizedAddress,
    splitAddressIntoStreetAndCityStateZip, validateCardNumber
} from "../../shared/sharedFunctions";
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import CustomInput from "../../shared/components/CustomInput";
import {allStates, states} from "../../shared/StatesDropdown";
import FormSelectCustom from "../../shared/components/FormSelectCustom";

interface LinkCCModalProps {
    show: boolean;
    toggle: () => void;
    onSubmit: (data: any) => void;
    billingInfo: any;
    customerAddress?: any;
}

const LinkCCModal: React.FC<LinkCCModalProps> = ({show, toggle, onSubmit, billingInfo, customerAddress}) => {
    const {register, trigger, getValues, setValue, formState: {errors}} = useForm();
    const [sameAsCustomer, setSameAsCustomer] = useState(false);
    const handleSubmit = async () => {
        const validation = await trigger()
        if(!validation)
            return
        onSubmit(getValues())
    }
    
    useEffect(() => {
        if (show) {
            setValue("name", billingInfo.billingName);
            setValue("cardNumber", '');
            setValue("expDate", '');
            setValue("securityCode", '');

            if (sameAsCustomer && customerAddress) {
                setValue("billingAddress", customerAddress.address);
                setValue("billingCity", customerAddress.city);
                setValue("billingState", customerAddress.state);
                setValue("billingPostalCode", customerAddress.zip);
                setValue("name", customerAddress.name);
            } else {
                setValue("billingAddress", billingInfo.billAddress);
                setValue("billingCity", billingInfo.billCity);
                setValue("billingState", billingInfo.billState);
                setValue("billingPostalCode", billingInfo.billPostal);
            }
        }
    }, [show, sameAsCustomer, customerAddress]);

    const handleExpDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let val = e.target.value.replace(/\D/g, '').slice(0, 4); // Remove non-digits
        if (val.length >= 3) val = val.slice(0, 2) + '/' + val.slice(2);
        setValue("expDate", val);
    };
    return (
        <Modal show={show} onHide={toggle}>
            <Modal.Header>
                <h4 className="modal-title" id="exampleModalLabel">Edit Billing Info</h4>
                <button onClick={toggle} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </Modal.Header>
            <Modal.Body>
                <div className="row gx-3">
                    <div className="col-md-12 mb-3">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="sameAsCustomer"
                            checked={sameAsCustomer}
                            onChange={() => setSameAsCustomer(prev => !prev)}
                        />
                        <label className="form-check-label" htmlFor="sameAsCustomer">
                            {' '}Billing address same as Customer address
                        </label>
                    </div>
                </div>
                <div className="row gx-3">
                    <div className="col-md-12 mb-3">
                        <CustomInput label={'Billing Name'} name={'name'} className={'form-control'} register={register}
                                     errors={errors} required/>

                    </div>
                </div>
                <div className="row gx-3">
                    <div className="col-12 mb-3">
                        <CustomInput label={'Billing Address'} name={'billingAddress'} className={'form-control'}
                                     register={register} errors={errors} required/>
                    </div>
                </div>
                <div className="row gx-3">
                    <div className="col-5 mb-3">
                        <CustomInput label={'City'} name={'billingCity'} className={'form-control'}
                                     register={register} errors={errors} required/>
                    </div>
                    <div className="col-3 mb-3">
                        <FormSelectCustom
                            label='State'
                            name="billingState"
                            className={'form-control'}
                            register={register}
                            options={allStates}
                            required
                        />
                    </div>
                    <div className="col-4 mb-3">
                        <CustomInput label={'Zip'} name={'billingPostalCode'} className={'form-control'}
                                     register={register} errors={errors} required/>
                    </div>
                </div>
                <div className="row gx-3">
                    <div className="col-12 mb-3">
                        <CustomInput label={'Card Number'} name={'cardNumber'} className={'form-control'}
                                     register={register} errors={errors}
                                     onChange={(e) => {
                                         const raw = e.target.value;
                                         const formatted = formatCardNumber(raw);
                                         setValue("cardNumber", formatted);
                                     }}
                                     validation={{
                                         validate: (value: string) =>
                                             !value || validateCardNumber(value) || "Invalid card number"
                                     }}
                        />
                    </div>
                </div>
                <div className="row gx-3">
                    <div className="col-md-6 mb-3">
                        <CustomInput label={'Exp Date'} name={'expDate'} className={'form-control'} register={register}
                                     errors={errors} onChange={handleExpDateChange} validation={{
                            validate: (value: string) =>
                                !value || /^(0[1-9]|1[0-2])\/\d{2}$/.test(value) || 'Format should be MM/YY',
                        }}/>
                    </div>
                    <div className="col-md-6 mb-3">
                        <CustomInput label={'CVV'} name={'securityCode'} className={'form-control'} register={register}
                                     errors={errors}/>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button onClick={toggle} type="button" className="btn btn-light text-strong m-100"
                        data-bs-dismiss="modal">Cancel
                </button>
                <button onClick={handleSubmit} type="button" className="btn btn-primary text-strong m-100"
                        data-bs-target="#updateBilling"
                        data-bs-toggle="modal">Done
                </button>
            </Modal.Footer>
        </Modal>
    );
}
export default LinkCCModal;
